<template>
  <div v-if="visible" class="auth-h5-overlay" @click.self="close">
    <div class="auth-h5-panel" @click.stop>
      <div class="auth-h5-title">授权信息确认</div>
      <p class="auth-h5-desc">
        H5 端占位组件：活动如需手机号/昵称校验，请后续接入与小程序一致的提交流程。
      </p>
      <button type="button" class="auth-h5-btn" @click="confirm">我知道了</button>
    </div>
  </div>
</template>

<script>
/**
 * 与小程序 authorization-confirmation 同名占位，保证 activity-multi 可编译运行。
 * 暴露 open()，成功时 $emit('registerSuccess')。
 */
export default {
  name: 'AuthorizationConfirmation',
  props: {
    requirePhone: { type: Boolean, default: false },
    requireNickname: { type: Boolean, default: false },
    requireStaff: { type: Boolean, default: false }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    confirm() {
      this.visible = false
      this.$emit('registerSuccess')
    }
  }
}
</script>

<style scoped>
.auth-h5-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}
.auth-h5-panel {
  width: 100%;
  max-width: 320px;
  background: #fff;
  border-radius: 10px;
  padding: 20px 18px 16px;
  box-sizing: border-box;
}
.auth-h5-title {
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
}
.auth-h5-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0 0 18px;
}
.auth-h5-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 6px;
  background: #1989fa;
  color: #fff;
  font-size: 16px;
}
</style>
